import { track } from './analytics';

/**
 * Centralized "Reserve" click handler. Fires the `Schedule` conversion
 * event (high intent, used by Meta Pixel/CAPI, Google Ads conversion,
 * TikTok, GA4) and opens Resy in a new tab.
 */
export const openReservation = (url, location = 'unknown') => {
  const target = url || 'https://resy.com/cities/los-angeles-ca/venues/bricklane';
  track('Schedule', { content_name: 'Reservation Click', location });
  if (typeof window !== 'undefined') {
    window.open(target, '_blank', 'noopener,noreferrer');
  }
};
